import React from 'react';

import { Box } from '@opendoor/bricks-next';

import type { EntryComponent } from '../../cms/entries/entries';
import type { IComponentMetricsCard, IMetricBasic } from '../../declarations/contentful';
import BasicMetric from './BasicMetric';

const renderMetricsCard = (entry: IComponentMetricsCard) => {
  return (
    <Box className="embedded-entry-wrapper" $platform-web={{ gridColumn: '5 / -2' }}>
      <Box
        gap="$5"
        py="$3"
        width="100%"
        flexWrap="nowrap"
        flexDirection="column"
        $largerThanSM={{ flexWrap: 'wrap', flexDirection: 'row' }}
      >
        {entry.fields.metrics?.map((x) => {
          if (x.sys.contentType.sys.id === 'metricBasic') {
            return (
              <React.Fragment key={x.sys.id}>
                {BasicMetric.render(x as IMetricBasic)}
              </React.Fragment>
            );
          }
          return null;
        })}
      </Box>
    </Box>
  );
};

const MetricsCard: EntryComponent<IComponentMetricsCard> = {
  render: renderMetricsCard,
};

export default MetricsCard;
